import { Directive, ViewContainerRef } from "@angular/core";

@Directive({
    selector: '[input]'
})
export class SimpleFilterInputDirective {
    constructor(public viewContainerRef: ViewContainerRef) {
    }
}